import { render, staticRenderFns } from "./ListPeriod.vue?vue&type=template&id=20e319b2&scoped=true"
import script from "./ListPeriod.vue?vue&type=script&lang=js"
export * from "./ListPeriod.vue?vue&type=script&lang=js"
import style0 from "./ListPeriod.vue?vue&type=style&index=0&id=20e319b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e319b2",
  null
  
)

export default component.exports